'use client';

import React from 'react';

interface RegenerateModalProps {
  currentEmail: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function RegenerateModal({ currentEmail, onConfirm, onCancel }: RegenerateModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm animate-fade-in"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-sm mx-4 card-elevated p-6 shadow-elevated animate-slide-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-warning/10 border border-warning/25 flex items-center justify-center flex-shrink-0">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFB830" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <div>
            <h3 className="text-base font-bold text-foreground">Regenerate address?</h3>
            <p className="text-xs text-muted-foreground mt-0.5">This action cannot be undone</p>
          </div>
        </div>

        <p className="text-sm text-secondary-foreground mb-2">
          Your current address will be permanently deleted:
        </p>
        <p className="text-sm font-mono font-semibold text-foreground bg-muted px-3 py-2 rounded-lg mb-4 break-all">
          {currentEmail}
        </p>
        <p className="text-sm text-secondary-foreground mb-6">
          Any messages sent to this address after deletion will not be delivered. A new random address will be generated immediately.
        </p>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="btn-ghost flex-1"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-2.5 px-4 rounded-lg bg-warning/15 border border-warning/30 text-warning font-semibold text-sm hover:bg-warning/25 transition-all duration-150 active:scale-95"
          >
            Regenerate address
          </button>
        </div>
      </div>
    </div>
  );
}